export const TEST_ID = 'activityCardItem';
